/* global $, Handlebars */

import Abstract from './abstract';

const INITIAL_STATE = {
  isRequested: false
};

export default class LoadMoreView extends Abstract {
  constructor() {
    super();

    this.setTemplate();
  }

  initState() {
    this.state = Object.assign({}, INITIAL_STATE);
  }

  getElement() {
    this.container = document.querySelector('.js-load-more-container');
    this.trigger = document.querySelector('.js-load-more-button');
  }

  addEvent() {
    this.trigger.addEventListener('click', this.onClick.bind(this));
  }

  onClick(e) {
    e.preventDefault();

    if (this.state.isRequested) return;

    this.onUpdateState({
      isRequested: true
    });

    const requestBody = {
      start_cursor: this.trigger.dataset.nextCursor,
      gam_count: Array.prototype.slice.call(document.querySelectorAll('.js-article-list-gam')).length
    };

    $.ajax({
      url: location.href,
      data: requestBody,
      dataType: 'json',
      success: response => this.callback(response)
    });
  }

  callback(response) {
    if (!response.next_cursor) {
      this.trigger.remove();
    } else {
      this.trigger.dataset.nextCursor = response.next_cursor;

      this.onUpdateState({
        isRequested: false
      });
    }

    const newArticles = this.getNewArticles(response.items);

    $(this.container).append(newArticles);
  }

  getNewArticles(items) {
    const templateType = this.trigger.dataset.templateType;
    const templateCreator = Handlebars.compile(this[`${templateType}Template`]);

    return templateCreator({
      items: items
    });
  }

  setTemplate() {
    this.commonTopTemplate = `
      {{#each items}}
        {{!-- GAM --}}
        {{#with gam_tag_id}}
          <li class="commonTop-Articles_Item js-article-list-gam" id="{{id}}">
            <script>
              googletag.cmd.push(function() {
                googletag.display("{{id}}");
              });
            </script>
          </li>
        {{else}}
          <li class="commonTop-Articles_Item">
            <a class="commonTop-Articles_Link" href="articles/{{id}}">
              <div class="commonTop-Articles_Thumbnail" style="background-image: url('{{thumbnail.image.url}}')"></div>
              <div class="commonTop-Articles_Information">
                <div class="commonTop-Articles_Title">{{title}}</div>
                {{#if sponsor}}
                <p class="commonTop-Articles_Author">PR &verbar; {{sponsor.name}}</p>
                {{else}}
                <p class="commonTop-Articles_Author">{{mediumItem.medium.name}}</p>
                {{/if}}
              </div>
            </a>
          </li>
        {{/with}}
      {{/each}}`;

    this.mediumArticlesTemplate = `
      {{#each items}}
        <li class="commonTop-Articles_Item">
          <a class="commonTop-Articles_Link" href="articles/{{id}}">
            <div class="commonTop-Articles_Thumbnail" style="background-image: url('{{thumbnail.image.url}}')"></div>
            <div class="commonTop-Articles_Information">
              <div class="commonTop-Articles_Title-large">{{title}}</div>
              {{#if sponsor}}
              <p class="commonTop-Articles_Author">PR &verbar; {{sponsor.name}}</p>
              {{else}}
              <p class="commonTop-Articles_Author">{{mediumItem.medium.name}}</p>
              {{/if}}
            </div>
          </a>
        </li>
      {{/each}}`;

    this.matomeTemplate = `
      {{#each items}}
        <div class="commonTop-Matomes_Item">
          <dt class="commonTop-Matomes_Header">{{title}}</dt>
          <dd class="commonTop-Matomes_Detail">
            <ul class="commonTop-Articles">
              {{#each articles}}
              <li class="commonTop-Articles_Item">
                <a class="commonTop-Articles_Link" href="articles/{{id}}">
                  <div class="commonTop-Articles_Thumbnail" style="background-image: url('{{thumbnail.image.url}}')"></div>
                  <div class="commonTop-Articles_Information">
                    <div class="commonTop-Articles_Title">{{title}}</div>
                    {{#if sponsor}}
                    <p class="commonTop-Articles_Author">PR &verbar; {{sponsor.name}}</p>
                    {{else}}
                    <p class="commonTop-Articles_Author">{{mediumItem.medium.name}}</p>
                    {{/if}}
                  </div>
                </a>
              </li>
              {{/each}}
            </ul>
            <a class="commonTop-Matomes_MoreButton navigate-button" href="matomes/{{id}}">
              この特集をもっと見る
            </a>
          </dd>
        </div>
      {{/each}}`;

    this.matomeArticleTemplate = `
      {{#each items}}
        <li class="matomes-Articles_Item">
          <a class="matomes-Articles_Link" href="articles/{{id}}">
            <div class="matomes-Articles_Thumbnail" style="background-image: url('{{thumbnail.image.url}}')"></div>
            <div class="matomes-Articles_Information">
              <div class="matomes-Articles_Title">{{title}}</div>
              {{#if sponsor}}
              <p class="matomes-Articles_Author">PR &verbar; {{sponsor.name}}</p>
              {{else}}
              <p class="matomes-Articles_Author">{{mediumItem.medium.name}}</p>
              {{/if}}
            </div>
          </a>
        </li>
      {{/each}}`;

    this.personalityQuizTemplate = `
      {{#each items}}
        <li class="commonTop-PersonalityQuizzes_Item">
          <a class="commonTop-PersonalityQuizzes_Link" href="personality-quizzes/{{id}}">
            <div class="commonTop-PersonalityQuizzes_Thumbnail" style="background-image: url('{{thumbnail.image.url}}')"></div>
            <div class="commonTop-PersonalityQuizzes_Title">{{title}}</div>
          </a>
        </li>
      {{/each}}`;

    this.searchedArticleTemplate = `
      {{#each items}}
        <li class="search-ResultArticles_Item">
          <a class="search-ResultArticles_Link" href="articles/{{id}}">
            <div class="search-ResultArticles_Thumbnail" style="background-image: url('{{thumbnail.image.url}}')"></div>
            <div class="search-ResultArticles_Information">
              <div class="search-ResultArticles_Title">{{title}}</div>
              {{#if sponsor}}
              <p class="search-ResultArticles_Author">PR &verbar; {{sponsor.name}}</p>
              {{else}}
              <p class="search-ResultArticles_Author">{{mediumItem.medium.name}}</p>
              {{/if}}
            </div>
          </a>
        </li>
      {{/each}}`;
  }
}
